// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ebfc869e","239":"c6763960","453":"1e4c8e99","732":"378eeaee"}[chunkId] + ".chunk.js";
};